import { Inline, Box, TooltipRenderer, Text } from 'braid-design-system';
import { format } from 'date-fns/format';

interface ExpiryDateRendererProps {
  expiryDate: string;
}

export const ExpiryDateRenderer = ({ expiryDate }: ExpiryDateRendererProps) => {
  const date = new Date(expiryDate);
  const dateOnlyString = format(date, 'dd-MMM-yyyy');

  const isExpired = date < new Date();

  const message = isExpired ? (
    <Text size="small">
      This invitation expired on{' '}
      {format(date, "EEEE do 'of' LLLL, yyyy 'at' h:mm a")}
    </Text>
  ) : (
    <Text size="small">
      This invitation will expire on{' '}
      {format(date, "EEEE do 'of' LLLL, yyyy 'at' h:mm a")}
    </Text>
  );

  return (
    <TooltipRenderer
      id={`expiryDateTooltip-${dateOnlyString}`}
      tooltip={message}
    >
      {({ triggerProps }) => (
        <Inline space="none">
          <Box {...triggerProps}>
            {isExpired ? (
              <Text tone="critical">{dateOnlyString}</Text>
            ) : (
              <Text tone="secondary">{dateOnlyString}</Text>
            )}
          </Box>
        </Inline>
      )}
    </TooltipRenderer>
  );
};
